<nb-list>
  <nb-list-item
    *ngFor="let thread of threads | async"
    (click)="onThreadSelected(thread)"
    class="position-relative thread-list"
  >
    <nb-user
      [name]="thread.name"
      size="large"
      [ngClass]="{
        online: isThreadOnline(thread),
        offline: !isThreadOnline(thread)
      }"
      color="primary"
      [title]="getThreadStatusText(thread)"
    ></nb-user>
    <ng-container *ngIf="thread.unSeenCount as unSeenCount">
      <nb-badge
        *ngIf="unSeenCount"
        [text]="unSeenCount"
        status="danger"
        possition="top end"
        class="m-3"
      ></nb-badge>
    </ng-container>
  </nb-list-item>
</nb-list>
